<template>
  <div class="dash-icons">
    <router-link
      :to="{ path: '/console/dashboard/property/' + propertyId + '/feedback' }"
    >
      <img class="white" src="../assets/home2.svg" /> </router-link
    ><br />
    <router-link
        :to="{
          path: '/console/dashboard/property/' + propertyId + '/feedbacksummary/list'
        }"
    >
      <img class="white" src="../assets/news.svg" /> </router-link
    ><br />
    <router-link
      :to="{
        path: '/console/dashboard/property/' + propertyId + '/feedback/list'
      }"
    >
      <img class="white" src="../assets/feedback.svg" /> </router-link
    ><br />
    <router-link
      :to="{
        path:
          '/console/dashboard/property/' +
          propertyId +
          '/feedback/customerjourney'
      }"
    >
      <img class="white" src="../assets/cj.svg" /> </router-link
    ><br />
    <router-link
      :to="{
        path:
          '/console/dashboard/property/' + propertyId + '/feedback/fileupload'
      }"
    >
      <img class="white" src="../assets/upload.svg" /> </router-link
    ><br />
  </div>
</template>

<script>
export default {
  name: "HeaderDashboard",
  props: {
    propertyId: {
      default: 0,
      type: Number
    }
  },
  data() {
    return {
      msg: 0
    };
  }
};
</script>

<style scoped>
.dash-icons {
  width: 100%;
  text-align: center;
  padding-top: 6px;
}
.dash-icons a {
  color: white;
  text-align: center;
}
.dash-icons .white {
  padding-bottom: 15px;
}
</style>
